import React, { useState } from 'react';

import Col from 'react-bootstrap/Col';
import ErrorBoundary from '../../utilities/ErrorBoundary';
import LeadSourceEditor from './LeadSourceEditor';
import LeadSourceList from './LeadSourceList';
import Row from 'react-bootstrap/Row';

const LeadSourceView = () => {
    const [item, setEditItem] = useState(undefined);

    return (
        <ErrorBoundary>
            {item === undefined ?
                (
                    <Row>
                        <Col>
                            <LeadSourceList
                                setEditItem={(i) => setEditItem(i)}
                            />
                        </Col>
                    </Row>
                ) : (
                    <Row>
                        <Col>
                            <LeadSourceEditor
                                item={item}
                                cancelEdit={() => setEditItem(undefined)}
                            />
                        </Col>
                    </Row>
                )}
        </ErrorBoundary>
    );
}

export default LeadSourceView;